t = require('app/scripts/views/internal/teacup-with-helpers')()
templates = require 'app/scripts/views/internal/templates'
View = require 'app/scripts/views/internal/view'

template = t.renderable ({ @newBillableGuests }) ->
  t.ul '.pop-over-member-list.js-billable-guest-list'

module.exports = class BillableGuestListPopoverView extends View
  viewTitleKey: 'billable guest list'
  initialize: ({ @newBillableGuests }) ->
  render: ->
    @$el.html template({ @newBillableGuests })
    $billableGuestList = @$('.js-billable-guest-list').first().empty()

    for member in @newBillableGuests
      data = Object.assign(
        member,
        { url: "/#{member.username}", unconfirmed: !member.confirmed }
      )
      $billableGuestList.append(
        templates.fill(
          'select_member',
          data,
          {},
          { member: templates.member }
        )
      )
    @
